import { defineComponent as _defineComponent } from 'vue'
import BundleProduct from './UpsellBundleProduct.vue';
import ButtonSpinner from 'JS/components/ButtonSpinner.vue';
import CarouselTrackingService from 'JS/services/CarouselTrackingService';
import Icon from 'JS/components/Icon.vue';
import { BCheckbox, BForm, BSubmitButton } from 'JS/components/blain-form';
import { computed, onMounted, reactive } from 'vue';
import { getPriceMode } from '../../../types/Product';
import { ICarouselViewGtmData, IProductCarouselGtmProduct } from '../../../types/Carousel';
import { IUpsellBundle } from 'JS/types/PDP';
import { useBreakpoints } from 'JS/composables/breakpoint';


export default /*#__PURE__*/_defineComponent({
  __name: 'UpsellBundle',
  props: {
    bundle: null,
    loading: { type: Boolean }
  },
  emits: ["add-to-cart"],
  setup(__props: any) {

const props = __props as {
	bundle: IUpsellBundle,
	loading: boolean
}

const _trackingSvc = new CarouselTrackingService();





const { isDesktop } = useBreakpoints();

const productInfoMap = props.bundle.products.reduce(
	(object, product) => Object.assign(
		object, {
			[product.blainNumber]: { price: null, ...product }
		}
	), {}
);

const selectedMap = reactive<Record<string, boolean>>(
	props.bundle.products.reduce(
		(object, product) => Object.assign(object, { [product.blainNumber]: true }),
		{}
	)
);

const productIsSelected = (bn: string) => selectedMap[bn];

const selectedProducts = computed<string[]>(
	() => Object.keys(selectedMap).filter(bn => productIsSelected(bn))
);

const submitButtonCallout = computed(() => {
	const { length } = selectedProducts.value;

	if (length >= 3) {
		return `Add All ${length} to Cart`;

	} else if (length == 2) {
		return 'Add Both to Cart';

	} else {
		return 'Add to Cart';
	}
});

const submitButtonAriaLabel = computed<string>(() => {
	const productList = selectedProducts.value.map(
		bn => productInfoMap[bn].name
	);

	if (productList.length) {
		return `Add ${productList.length} items from ${props.bundle.title ?? 'this bundle'} to your cart: `
            + productList.join(', ')
            + ''
            + (subtotalIsMessage() ? subtotal.value : `Subtotal: $${subtotal.value}`);
	} else {
		return 'No bundle items selected to add to cart.';
	}
});

const subtotal = computed<string>(() => {
	let total = 0;

	for (const product of props.bundle.products) {
		if (!productIsSelected(product.blainNumber)) {
			continue;

		} else if (product.price.hidePrice) {
			return product.price.priceAltText;

		} else {
			total += parseFloat(product.price.price.replace(',',''));
		}
	}

	if (total) {
		return total.toCurrency();
	} else return null;
});

const subtotalIsMessage = () => isNaN(parseInt(subtotal.value));

const subtotalInnerHtml = computed<string>(() => {
	if (!subtotal.value) {
		return 'Select items to add';
	}

	if (subtotalIsMessage()) {
		return subtotal.value;
	}

	return `Subtotal: <span class="bundle-subtotal">$${subtotal.value}</span>`;
});


onMounted(() => {
	const carouselProducts: IProductCarouselGtmProduct[] = [];
	props.bundle.products.forEach(product => {
		carouselProducts.push({
			blainNumber: product.blainNumber,
			vendorBrand: product.brand,
			productName: product.name,
			price: product.price,
			belowMap: product.price.isBelowMAP,
			priceMode: getPriceMode(product.price)
		});
	});

	const gtmData: ICarouselViewGtmData = {
		itemListID: "bundle_upsell",
		itemListName: "PDP Bundle Upsell",
		carouselProducts
	};

	_trackingSvc.trackViews([], [gtmData]); // NOTE: Not tracking in internal carousel tracker for the time being.
});

return { __sfc: true,_trackingSvc, props, isDesktop, productInfoMap, selectedMap, productIsSelected, selectedProducts, submitButtonCallout, submitButtonAriaLabel, subtotal, subtotalIsMessage, subtotalInnerHtml, BundleProduct, ButtonSpinner, Icon, BCheckbox, BForm, BSubmitButton }
}

})